<template>

  <div>
    <div
      class="buymodal-block__body">

      <div
        class="body-info">
        <div
          class="body-info__title">
          Данные об устройстве
        </div>
        <div
          class="body-info__block">
          <div
            class="info-table">
            <div
              class="info-table__line">
              <div
                class="label">
                Серийный номер
              </div>
              <div
                class="value">
                {{ model.sn }}
              </div>
            </div>
            <div
              class="info-table__line"
              v-for="(item, i) in model.device" :key="i"
              v-if="i != 'code' && i != 'type' && ((model.device['model']==null && i == 'fullName') || (model.device['model'] && i != 'fullName' )) && i != 'GPS' && i != 'cellular' && i != 'color' && item">
              <div
                class="label">
                {{ i == 'generation' ? 'Поколение' : i == 'model' ? 'Модель' : i == 'size' ? 'Размер' : i == 'fullName' ? 'Модель' : i }}
              </div>
              <div
                class="value">
                {{ item }}
              </div>
            </div>
          </div>
          <div
            class="info-image">
            <div
              class="info-image__img">
              <img
                src="@/../static/img/image.jpg">
            </div>
            <!-- <button
              type="button"
              class="btn disagree"
              @click.prevent="$emit('badmodel')">
              Модель определена неверно
            </button> -->
          </div>
        </div>
      </div>

    </div>

    <div
      class="buymodal-block__footer">
      <button
        type="button"
        class="btn cancel"
        @click.prevent="$emit('leave')">
        Отказаться
      </button>
      <button
        type="button"
        class="btn next"
        @click.prevent="$emit('next')">
        Продолжить
      </button>
    </div>

  </div>

</template>

<script>
export default {
  props: ['model'],
}
</script>

<style lang="css">
</style>
